import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-dark text-zinc-100 font-sans selection:bg-brand-orange selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <PainPoints data-id="element-3" />
      <Volumes data-id="element-4" />
      <Bonuses data-id="element-5" />
      <Pricing data-id="element-6" />
      <Testimonials data-id="element-7" />
      <FAQ data-id="element-8" />
      <Footer data-id="element-9" />
      <PurchasePopup data-id="element-10" />
    </div>;
}